export default __webpack_public_path__ + "static/media/brasil-flag.2f9c54e9.svg";